import React from "react";
import Radium from "radium";

const DemoModeTag = (props) => (
    <div style={[{
        color: "white",
        backgroundColor: "rgba(0, 120, 231, 0.5)",
        padding: "0.15em 0.5em",
        borderRadius: "3px",
    }, props.style ]}>{props.children}</div>
);
DemoModeTag.propTypes = {
    style: React.PropTypes.object
};

export default Radium(DemoModeTag)



/** WEBPACK FOOTER **
 ** ./src/main/javascript/compliance/components/DemoModeTag.js
 **/